/**
 * <BrandConcierge /> — code-enforced trademark protection
 *
 * Doctrine source: TDC-Doctrine-Correction-Concierge-R-and-Named-Concierge.md (23 May 2026)
 * Founder directive: "If a brand has a registered mark, it belongs in the very first
 * character we type when we name it. Not added later. Not assumed to be obvious."
 *
 * Use this component wherever the noun "Concierge" appears in any branded LC context.
 * The ® is rendered as a small superscript that respects the surrounding text style.
 *
 * Examples:
 *   <BrandConcierge />                        →  Concierge®
 *   <BrandConcierge plural />                 →  Concierges®
 *   <BrandConcierge plural withPossessive />  →  Les Concierges®
 *
 * Do NOT hardcode "Concierge®" as a string literal in member-facing surfaces.
 * Use this component so renames, font tweaks, and i18n stay correct in one place.
 */

import React from "react";

export function BrandConcierge({ plural = false, leadingArticle = "", className = "", testid }) {
  const noun = plural ? "Concierges" : "Concierge";
  return (
    <span className={className} data-testid={testid}>
      {leadingArticle && <>{leadingArticle} </>}
      {noun}
      <sup
        style={{
          fontSize: "0.55em",
          marginLeft: "0.05em",
          fontWeight: "normal",
          verticalAlign: "super",
          lineHeight: 0,
        }}
        aria-label="registered trademark"
      >
        ®
      </sup>
    </span>
  );
}

/**
 * <BrandLine /> — full "Les Concierges®" brand line in one component.
 * Use for the masthead, footer, and any place the entire registered brand appears.
 */
export function BrandLine({ className = "", testid }) {
  return (
    <span className={className} data-testid={testid || "brand-line"}>
      Les Concierges
      <sup
        style={{
          fontSize: "0.55em",
          marginLeft: "0.05em",
          fontWeight: "normal",
          verticalAlign: "super",
          lineHeight: 0,
        }}
        aria-label="registered trademark"
      >
        ®
      </sup>
    </span>
  );
}
